import { render, staticRenderFns } from "./LibrarySort.vue?vue&type=template&id=3a95d5c8&"
import script from "./LibrarySort.vue?vue&type=script&lang=js&"
export * from "./LibrarySort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports